import { type AccountCode } from '@webapp/platform/finance'

export const stringifyAccountCode = (accountCode: AccountCode) => {
  return `${accountCode.code} - ${accountCode.description}`
}
